import Navbar from "@/components/Mobile/Navbar.vue";
import Messages from "@/views/private/Messages.vue";
import Contact from "@/views/private/messages/Contact.vue";
import Handicap from "@/views/private/messages/Handicap.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/messages",
        name: RouteEnum.MESSAGE,
        components: {
            default: Messages,
            footer: Navbar
        },
    },
    {
        path: "/messages",
        children: [
            {
                path: "contact",
                name: RouteEnum.MESSAGE_CONTACT,
                components: {
                    default: Contact,
                    footer: Navbar
                },
            },
            {
                path: "referent-handicap",
                name: RouteEnum.MESSAGE_REFERENT_HANDICAP,
                components: {
                    default: Handicap,
                    footer: Navbar
                },
            },
        ]
    }
];
